/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import FullTable from 'src/common/components/FullTable';
import { useHistory, useLocation } from 'react-router-dom';
import { sessionsAPI } from 'src/api/modules/sessions';
import { institutionsAPI } from 'src/api/modules/institutions';
import { topicAPI } from 'src/api/modules/topic';
import notice from 'src/common/components/Notice';
import { useSelector } from 'react-redux';
import { formatDate } from 'src/utils/dates';
import { organsAPI } from 'src/api/modules/organs';
import DeleteConsultModal from './DeleteConsultModal';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import {
	columns,
	defaultFilter,
	filterTab1,
	filterTab2,
	filterTab3,
} from '../utils/list_data';

const SearchByNumber = ({ tab }) => {
	const history = useHistory();
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [numberPage1, setNumberPage1] = useState(1);
	const [numberPage2, setNumberPage2] = useState(1);
	const [numberPage3, setNumberPage3] = useState(1);
	const [recordsPage1, setRecordsPage1] = useState(5);
	const [recordsPage2, setRecordsPage2] = useState(5);
	const [recordsPage3, setRecordsPage3] = useState(5);
	const [filter, setFilter] = useState(defaultFilter);
	const [totalResults1, setTotalResults1] = useState(null);
	const [totalResults2, setTotalResults2] = useState(null);
	const [totalResults3, setTotalResults3] = useState(null);
	const [byResolution, setBR] = useState();
	const [bySessionInstitution, setBSI] = useState();
	const [bySession, setBS] = useState();
	const [sessions, setSessions] = useState([]);
	const [institutions, setInstitutions] = useState([]);
	const [mounted, setMounted] = useState(false);
	const [organs, setOrgans] = useState([]);
	const [canRemove, setCanRemove] = useState(false);
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	const [modalDelete, setModalDelate] = useState(false);
	const [idRes, setIdRes] = useState();
	const showEverything = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];
	const removeResolution = [
		'ADMINISTRADOR GENERAL',
		'SISTEMA',
		'RESPONSABLE DE NEGOCIO',
		'RESPONSABLE DE SEGUIMIENTO',
	];

	useEffect(() => {
		getInstitutions();
		getOrgans();
		if (removeResolution.includes(systemLevelRole) === true) setCanRemove(true);
	}, []);

	const getOrgans = () => {
		if (showEverything.includes(systemLevelRole) === true) {
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setOrgans(getAllOrgans(response));
					}
				})
				.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
		} else {
			setOrgans(reduxOrgan);
		}
	};

	const getSessionsByOrgan = (organ) => {
		let sessionByOrgan = [];
		setSessions([]);
		sessionsAPI
			.getByOrgan(organ)
			.then((response) => {
				if (response.sesiones.length > 0) {
					response.sesiones.forEach((item) => {
						sessionByOrgan.push({
							value: item.id,
							text: item.numero_sesion,
						});
					});
					setSessions(sessionByOrgan);
				} else {
					notice(
						'No se encontraron sesiones para el organo seleccionado',
						'warning'
					);
				}
			})
			.catch((e) => notice('Ha ocurrido un error al cargar las sesiones'));
	};

	const getInstitutions = () => {
		institutionsAPI
			.get('unidadAdministrativa')
			.then((response) => {
				if (response && response.length > 0) {
					let institutionsFlag = [];
					response.forEach((ele) => {
						institutionsFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setInstitutions([...(institutionsFlag || [])]);
				} else setInstitutions([]);
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;
		let queryFilters = { ...filter };
		queryFilters = { ...queryFilters, [name]: value };
		setFilter({ ...filter, [name]: value });
		const params = new URLSearchParams(location.search);
		params.set('tab', tab);
		if (tab === 1) {
			params.set('resolution', queryFilters.resolution);
			params.set('organ1', queryFilters.organ1);
			params.set('status1', queryFilters.status1);
		}
		if (tab === 2) {
			params.set('institutionA', queryFilters.institutionA);
			params.set('institutionR', queryFilters.institutionR);
			params.set('organ2', queryFilters.organ2);
			params.set('status2', queryFilters.status2);
		}
		if (tab === 3) {
			params.set('sessionTab3', queryFilters.sessionTab3);
			params.set('organ3', queryFilters.organ3);
			params.set('status3', queryFilters.status3);
		}

		if (name === 'organ3') {
			getSessionsByOrgan(value);
		}

		history.push({ search: params.toString() });
	};

	const onEye = (id) => history.push(`/seguimiento/resolucion/${id}`);

	const onClear = () => {
		if (tab === 1) {
			setFilter({
				sessionTab3: filter.sessionTab3,
				organ2: filter.organ2,
				organ3: filter.organ3,
				institutionR: filter.institutionR,
				institutionA: filter.institutionA,
				organ1: '',
				resolution: '',
				status1: '',
			});
			setBR([]);
		} else if (tab === 2) {
			setFilter({
				resolution: filter.resolution,
				sessionTab3: filter.sessionTab3,
				organ1: filter.organ1,
				organ3: filter.organ3,
				institutionA: '',
				institutionR: '',
				organ2: '',
				status2: '',
			});
			setBSI([]);
		} else if (tab === 3) {
			setFilter({
				resolution: filter.resolution,
				sessionTab2: filter.sessionTab2,
				institutionR: filter.institutionR,
				institutionA: filter.institutionA,
				organ1: filter.organ1,
				organ2: filter.organ2,
				sessionTab3: '',
				organ3: '',
				status3: '',
			});
			setBS([]);
			setSessions([]);
		}
	};

	const onConfirmFilter = () => {
		setLoading(true);
		let userPromise = null;
		switch (tab) {
			case 1:
				if (!filter.organ1) {
					return notice('Debe Seleccionar un Organo', 'warning');
				}
				userPromise = topicAPI.getByOrganPredictiveResolution(
					filter.organ1,
					filter.resolution,
					filter.status1,
					numberPage1,
					recordsPage1
				);
				notice('Buscando Resultados', 'info');
				break;
			case 2:
				if (!filter.organ2) {
					return notice('Debe Seleccionar un Órgano', 'warning');
				}
				userPromise = topicAPI.getByOrganSessionInstitution(
					filter.organ2,
					filter.institutionR !== '' ? filter.institutionR : 0,
					filter.institutionA !== '' ? filter.institutionA : 0,
					filter.status2,
					numberPage2,
					recordsPage2
				);
				break;
			case 3:
				if (!filter.organ3) {
					return notice('Debe Seleccionar un Órgano', 'warning');
				}
				if (!filter.sessionTab3) {
					return notice('Debe Seleccionar una Sesión', 'warning');
				}
				userPromise = topicAPI.getByOrganSession(
					filter.organ3,
					filter.sessionTab3,
					filter.status3,
					numberPage3,
					recordsPage3
				);
				break;
			default:
				break;
		}
		userPromise
			.then((response) => {
				if (response.codigo === 'SAOC-400' || response.codigo === 'SAOC: 500')
					notice(JSON.parse(JSON.stringify(response.mensaje)));
				else if (response.temas && response.temas.length > 0) {
					let newResponse = [];
					response.temas.forEach((item) => {
						newResponse.push({
							...item,
							fechaLimite: item.fechaLimite
								? item.fechaLimite.split('-').reverse().join('/')
								: '',
						});
					});

					newResponse = newResponse.sort((a, b) => {
						return b.id - a.id;
					});
					if (tab === 1) {
						setBR([]);
						setBR(newResponse);
						setTotalResults1(response.totalRegistros);
					}
					if (tab === 2) {
						setBSI([]);
						setBSI(newResponse);
						setTotalResults2(response.totalRegistros);
					}
					if (tab === 3) {
						setBS([]);
						setBS(newResponse);
						setTotalResults3(response.totalRegistros);
					}
				} else {
					notice('No se encontraron resultados', 'info');
					if (tab === 1) setBR([]);
					if (tab === 2) setBSI([]);
					if (tab === 3) setBS([]);
				}
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				if (isDev) {
					if (e.response.data === undefined || e.response.data === '') {
						notice('Ha ocurrido un error con su petición');
					} else notice(JSON.parse(JSON.stringify(e.response.data.mensaje)));
				} else notice('Ha ocurrido un error con su petición');
			});
	};

	const onModalDelete = (id) => {
		setModalDelate(true);
		setIdRes(id);
	};

	const onDelete = () => {
		let newResponse = [];
		topicAPI
			.enviarNotificacionResponsable(idRes, 'E')
			.then(() => {
				notice('Resolución/Recomendación eliminada', 'success');
				if (tab === 1) {
					newResponse = byResolution.filter((e) => {
						return e.id !== idRes;
					});
					setBR(newResponse);
				}
				if (tab === 2) {
					newResponse = bySessionInstitution.filter((e) => {
						return e.id !== idRes;
					});
					setBSI(newResponse);
				}
				if (tab === 3) {
					newResponse = bySession.filter((e) => {
						return e.id !== idRes;
					});
					setBS(newResponse);
				}
			})
			.catch((e) => notice('Ha ocurrido un error con su petición'));
		setModalDelate(false);
		setIdRes();
	};

	useEffect(() => {
		if (location.search.length > 2) {
			const params = new URLSearchParams(location.search);
			let newObj = {};
			if (tab === 1) {
				const resolution = params.get('resolution') || '';
				const organ1 = params.get('organ1') || '';
				const status1 = params.get('status1') || '';
				newObj = {
					resolution,
					organ1: organ1 ? Number(organ1) : '',
					status1,
				};
			}
			if (tab === 2) {
				const institutionA = params.get('institutionA') || '';
				const institutionR = params.get('institutionR') || '';
				const status2 = params.get('status1') || '';
				const organ2 = params.get('organ2') || '';
				newObj = {
					institutionA: institutionA ? Number(institutionA) : '',
					institutionR: institutionR ? Number(institutionR) : '',
					organ2: organ2 ? Number(organ2) : '',
					status2,
				};
			}
			if (tab === 3) {
				const sessionTab3 = params.get('sessionTab3') || '';
				const organ3 = params.get('organ3') || '';
				if (organ3) {
					getSessionsByOrgan(organ3);
				}
				const status3 = params.get('status3') || '';
				newObj = {
					sessionTab3: sessionTab3 ? Number(sessionTab3) : '',
					organ3: organ3 ? Number(organ3) : '',
					status3,
				};
			}
			setFilter({
				...filter,
				...newObj,
			});
		}
	}, []);
	useEffect(() => {
		const timer = setTimeout(() => {
			if (
				(filter.resolution ||
					filter.organ1 ||
					filter.status1 ||
					filter.sessionTab3 ||
					filter.organ3 ||
					filter.institutionA ||
					filter.institutionR ||
					filter.organ2 ||
					filter.status2 ||
					filter.status3) &&
				!mounted
			) {
				onConfirmFilter();
				setMounted(true);
			}
			setMounted(true);
		}, 2000);
		return () => clearTimeout(timer);
	}, [filter]);

	const handlePagination = (value) => {
		tab === 1
			? setRecordsPage1(value)
			: tab === 2
			? setRecordsPage2(value)
			: setRecordsPage3(value);
	};
	useEffect(() => {
		if (mounted) {
			onConfirmFilter();
		}
	}, [numberPage1, numberPage2, numberPage3, recordsPage1, recordsPage2, recordsPage3]);

	return (
		<div className="transparent-container">
			<FullTable
				isLoading={loading}
				idTable={'TableRes'}
				items={
					tab === 1
						? byResolution
						: tab === 2
						? bySessionInstitution
						: bySession
				}
				columns={columns(onModalDelete, onEye, canRemove)}
				filter={filter}
				filterForm={
					tab === 1
						? filterTab1(organs, onConfirmFilter, onClear)
						: tab === 2
						? filterTab2(institutions, onConfirmFilter, onClear, organs)
						: filterTab3(sessions, onConfirmFilter, onClear, organs)
				}
				onFilterChange={handleChangeFilter}
				ExcelFileName={`Resoluciones_Recomendaciones${formatDate('P p')}.xls`}
				showPagination
				handlePagination={handlePagination}
				sizePerPageTable={
					tab === 1 ? recordsPage1 : tab === 2 ? recordsPage2 : recordsPage3
				}
				totalPages={
					tab === 1 ? totalResults1 : tab === 2 ? totalResults2 : totalResults3
				}
				currentPage={
					tab === 1 ? numberPage1 : tab === 2 ? numberPage2 : numberPage3
				}
				setCurrentPage={
					tab === 1
						? setNumberPage1
						: tab === 2
						? setNumberPage2
						: setNumberPage3
				}
			/>
			<DeleteConsultModal
				open={modalDelete}
				setClose={setModalDelate}
				onDelete={onDelete}
			/>
		</div>
	);
};

export default SearchByNumber;
